import { useReducer } from 'react';

export interface DropdownState {
  isShowingSearch: boolean;
  isShowingMobileNav: boolean;
  isShowingDesktopNav: boolean;
  myNerdWalletMenu: {
    isOpen: boolean;
    source?: 'desktop' | 'mobile';
  };
  isNotificationSidebarOpen: boolean;
}

const TOGGLE_SEARCH = 'TOGGLE_SEARCH' as const;
const TOGGLE_DESKTOP_NAV = 'TOGGLE_DESKTOP_NAV' as const;
const TOGGLE_MOBILE_NAV = 'TOGGLE_MOBILE_NAV' as const;
const OPEN_MY_NERDWALLET_MENU = 'OPEN_MY_NERDWALLET_MENU' as const;
const CLOSE_MY_NERDWALLET_MENU = 'CLOSE_MY_NERDWALLET_MENU' as const;
const OPEN_NOTIFICATIONS = 'OPEN_NOTIFICATIONS' as const;
const CLOSE_NOTIFICATIONS = 'CLOSE_NOTIFICATIONS' as const;
const CLOSE_ALL = 'CLOSE_ALL' as const;

export type MyNerdWalletMenuDeviceType = 'desktop' | 'mobile';

export type Action =
  | {
      type:
        | typeof TOGGLE_SEARCH
        | typeof TOGGLE_MOBILE_NAV
        | typeof TOGGLE_DESKTOP_NAV
        | typeof CLOSE_MY_NERDWALLET_MENU
        | typeof OPEN_NOTIFICATIONS
        | typeof CLOSE_NOTIFICATIONS
        | typeof CLOSE_ALL;
    }
  | {
      type: typeof OPEN_MY_NERDWALLET_MENU;
      source: MyNerdWalletMenuDeviceType;
    };

export const TOGGLE_SEARCH_ACTION = { type: TOGGLE_SEARCH };
export const OPEN_MY_NERDWALLET_MENU_ACTION = (source: MyNerdWalletMenuDeviceType) => ({
  type: OPEN_MY_NERDWALLET_MENU,
  source,
});
export const CLOSE_MY_NERDWALLET_MENU_ACTION = { type: CLOSE_MY_NERDWALLET_MENU };
export const TOGGLE_MOBILE_NAV_ACTION = { type: TOGGLE_MOBILE_NAV };
export const TOGGLE_DESKTOP_NAV_ACTION = { type: TOGGLE_DESKTOP_NAV };
export const OPEN_NOTIFICATIONS_ACTION = { type: OPEN_NOTIFICATIONS };
export const CLOSE_NOTIFICATIONS_ACTION = { type: CLOSE_NOTIFICATIONS };
export const CLOSE_ALL_ACTION = { type: CLOSE_ALL };

const initialState: DropdownState = {
  isShowingSearch: false,
  isShowingMobileNav: false,
  isShowingDesktopNav: false,
  myNerdWalletMenu: {
    isOpen: false,
  },
  isNotificationSidebarOpen: false,
};

export function determineDropdown(state: DropdownState, action: Action): DropdownState {
  switch (action.type) {
    case TOGGLE_SEARCH: {
      const newState = {
        ...initialState,
        isShowingSearch: !state.isShowingSearch,
      };
      return newState;
    }
    case TOGGLE_DESKTOP_NAV: {
      const newState = {
        ...initialState,
        isShowingDesktopNav: !state.isShowingDesktopNav,
      };
      return newState;
    }
    case TOGGLE_MOBILE_NAV: {
      const newState = {
        ...initialState,
        isShowingMobileNav: !state.isShowingMobileNav,
      };
      return newState;
    }
    case OPEN_MY_NERDWALLET_MENU: {
      if (state.isNotificationSidebarOpen) {
        return { ...state };
      }
      const newState = {
        ...initialState,
        myNerdWalletMenu: {
          isOpen: true,
          source: action.source,
        },
      };
      return newState;
    }
    case CLOSE_MY_NERDWALLET_MENU: {
      if (state.isNotificationSidebarOpen) {
        return { ...state };
      }
      const newState = {
        ...initialState,
        myNerdWalletMenu: {
          isOpen: false,
        },
      };
      return newState;
    }
    case OPEN_NOTIFICATIONS: {
      const newState = {
        ...initialState,
        isNotificationSidebarOpen: true,
      };
      return newState;
    }
    case CLOSE_NOTIFICATIONS: {
      const newState = {
        ...initialState,
        isNotificationSidebarOpen: false,
      };
      return newState;
    }
    case CLOSE_ALL:
      return initialState;
    default:
      return state;
  }
}

export function useSingleDropdown() {
  return useReducer(determineDropdown, initialState);
}
